import Countdown from "react-countdown";
import Timer from "./timer";
import { useSelector } from "react-redux";

function TableHeader() {
  const endDate = new Date("April 16, 2023 23:59:59 UTC").getTime();
  const totalParticipants = useSelector(
    (state) => state.leaderboard.total
  );

  return (
    <div className="flex justify-between">
      <div>
        <p className="text-primary-text font-semibold text-xl">Leaderboard</p>
        <p className="text-secondary-text text-sm">
          {totalParticipants} traders
        </p>
      </div>
      <div className="text-right hidden sm:block">
        <Countdown date={endDate} renderer={Timer} />
        <p className="text-secondary-text text-sm">
          Ends on April 16th 23:59:59 UTC
        </p>
      </div>
    </div>
  );
}

export default TableHeader;
